<a id="TargetAngabenZurPerson"></a>
<div [formGroup]="form">
  <div class="card">
    <div class="card-header">
      <h3>
        <i class="icon-personendaten"></i> <span i18n>Angaben zur Person</span>
        <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span>
          </button>
        </span>
      </h3>
    </div>
    <div class="card-body">
      <div [ngbPopover]="popover_antrag_stellvertreter">
        <app-pass-restricted-checkbox
        *ngIf="this.appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
        [selectedCheckbox$]="selectStellvertreterDefaultCheckbox$"
        [required]="isRequired(form.controls.isStellvertreter)"
        [control]="form.controls['isStellvertreter']"
        [title]="'PROXY_TITLE'"
        [labels]="isStellVertreterRestrictedCheckboxLabels"
        appReadonlyBehaviour/>
      </div>
      <ng-template #popover_antrag_stellvertreter>
        <app-assistant (assistantDisabled)="disableAssistant()">
          <span i18n>
            Bitte wählen Sie Ja, wenn Sie den Antrag für sich selbst ausstellen und Nein,
            wenn Sie den Antrag für eine andere Person ausfüllen.
          </span>
        </app-assistant>
      </ng-template>
      <app-stell-vertreter appReadonlyBehaviour formControlName="stellvertreter" *ngIf="(isStellvertreter$ | async) && this.appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"/>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="float-start card-header card-header-detail" i18n>Personendaten des/der Antragstellenden</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.familienname" i18n [class.mandatory]="isMandatory('familienname')">Familienname:</label>
                    <input
                      id="antragsteller.familienname"
                      type="text"
                      appToUpperCase
                      [attr.maxlength]="getMaxLength('familienname')"
                      class="form-control form-control-sm"
                      [class.is-invalid]="errorClassRequired(form.controls['familienname'])"
                      formControlName="familienname"
                      [ngbPopover]="popover_antragsteller_familienname"
                      appSaveLastFocussed
                      #angabenZurPersonfirstInputFieldForFocus
                    >
                    <ng-template #popover_antragsteller_familienname>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier den Familiennamen des/der Antragstellenden in lateinischen Schriftzeichen ein (wie im Reisedokument angegeben). Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier den Familiennamen des/der Antragstellenden ein (wie im Reisedokument angegeben). Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">

                    <label for="antragsteller.geburtsname" i18n [class.mandatory]="isMandatory('geburtsname')"
                           *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">Geburtsname / frühere(r) Familienname(n):</label>
                    <label for="antragsteller.geburtsname" i18n [class.mandatory]="isMandatory('geburtsname')"
                           *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">Nachname bei der Geburt (frühere(r) Familienname(n)):</label>
                    <input id="antragsteller.geburtsname"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('geburtsname')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['geburtsname'])"
                           formControlName="geburtsname"
                           [ngbPopover]="popover_antragsteller_geburtsname"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_geburtsname>
                      <app-assistant (assistantDisabled)="disableAssistant()" *ngIf= "appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">
                        <span i18n>Bitte tragen Sie hier, sofern vorhanden, den Geburtsnamen des/der Antragstellenden ein (wie im Reisedokument angegeben). Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                      </app-assistant>
                      <app-assistant (assistantDisabled)="disableAssistant()" *ngIf= "appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                        <span i18n>Bitte tragen Sie hier, sofern vorhanden, den Nachnamen des/der Antragstellenden bei der Geburt bzw. den/die frühere(r) Familienname(n) ein (wie im Reisedokument angegeben). Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.vorname" i18n [class.mandatory]="isMandatory('vorname')">Vorname(n):</label>
                    <input id="antragsteller.vorname"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('vorname')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['vorname'])"
                           formControlName="vorname"
                           [ngbPopover]="popover_antragsteller_vorname"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_vorname>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier den/die Vornamen des/der Antragstellenden in lateinischen Schriftzeichen ein (wie im Reisedokument angegeben). Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.geburtsdatum" i18n [class.mandatory]="isMandatory('geburtsdatum')">Geburtsdatum (TT.MM.JJJJ):</label>
                    <input id="antragsteller.geburtsdatum"
                           type="text"
                           appDynamicDateMaxLength
                           appResetDateSpecialValues
                           appFixDate="past"
                           unknownReplacement="00"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['geburtsdatum'])"
                           formControlName="geburtsdatum"
                           [ngbPopover]="popover_antragsteller_geburtsdatum"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_geburtsdatum>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier das Geburtsdatum (im Format TT.MM.JJJJ) des/der Antragstellenden ein. Wenn der genaue Tag und/oder Monat des Geburtsdatums nicht bekannt ist, so können Sie für Tag und Monat hilfsweise jeweils 00 angeben. Das Geburtsjahr ist jedoch zwingend erforderlich.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.geburtsort" i18n [class.mandatory]="isMandatory('geburtsort')">Geburtsort:</label>
                    <input id="antragsteller.geburtsort"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('geburtsort')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['geburtsort'])"
                           formControlName="geburtsort"
                           [ngbPopover]="popover_antragsteller_geburtsort"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_geburtsort>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier den Geburtsort des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.geburtsland" i18n [class.mandatory]="isMandatory('geburtsland')">Geburtsland:</label>
                    <select id="antragsteller.geburtsland"
                            class="form-select form-select-sm"
                            [class.is-invalid]="errorClassRequired(form.controls['geburtsland'])"
                            formControlName="geburtsland"
                            [ngbPopover]="popover_antragsteller_geburtsland"
                            appSaveLastFocussed
                    >
                      <option value=""></option>
                      <option *ngFor="let listItem of landListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                    </select>
                    <ng-template #popover_antragsteller_geburtsland>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte wählen Sie hier das Geburtsland des/der Antragstellenden aus.</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier das Geburtsland des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.geschlecht" i18n [class.mandatory]="isMandatory('geschlecht')">Geschlecht:</label>
                    <select id="antragsteller.geschlecht"
                            class="form-select form-select-sm"
                            [class.is-invalid]="errorClassRequired(form.controls['geschlecht'])"
                            formControlName="geschlecht"
                            [ngbPopover]="popover_antragsteller_geschlecht"
                            appSaveLastFocussed
                    >
                      <option value="" selected></option>
                      <option *ngFor="let listItem of geschlechtListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                    </select>
                    <ng-template #popover_antragsteller_geschlecht>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte wählen Sie das Geschlecht des/der Antragstellenden aus (wie im Reisedokument angegeben).</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier das Geschlecht des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.familienstand" i18n [class.mandatory]="isMandatory('familienstand')">Familienstand:</label>
                    <select id="antragsteller.familienstand" class="form-select form-select-sm"
                            [class.is-invalid]="errorClassRequired(form.controls['familienstand'])"
                            formControlName="familienstand"
                            [ngbPopover]="popover_antragsteller_familienstand"
                            appSaveLastFocussed
                    >
                      <option value="" selected></option>
                      <option *ngFor="let listItem of familienstandListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                    </select>
                    <ng-template #popover_antragsteller_familienstand>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte wählen Sie hier den aktuellen Familienstand des/der Antragstellenden aus.</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier den Familienstand des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3" *ngIf="isFamilienstandSeitVisible">
                    <label for="antragsteller.familienstandUngleichLedigUndUnbekanntSeit" i18n [class.mandatory]="isMandatory('familienstandSeit')">Seit:</label>
                    <input id="antragsteller.familienstandUngleichLedigUndUnbekanntSeit"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('familienstandSeit')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['familienstandSeit'])"
                           formControlName="familienstandSeit"
                           [ngbPopover]="popover_antragsteller_familienstandUngleichLedigUndUnbekanntSeit"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_familienstandUngleichLedigUndUnbekanntSeit>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier ein, seit wann der aktuelle Familienstand besteht.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.staatsangehoerigkeitListe[0]" [class.mandatory]="isMandatory('derzeitigeStaatsangehoerigkeit1')" i18n
                    >Derzeitige Staatsangehörigkeit:</label>
                    <span>
                      <select id="antragsteller.staatsangehoerigkeitListe[0]" class="form-select form-select-sm mb-2"
                              [class.is-invalid]="errorClassRequired(form.controls['derzeitigeStaatsangehoerigkeit1'])"
                              formControlName="derzeitigeStaatsangehoerigkeit1"
                              [ngbPopover]="popover_antragsteller_staatsangehoerigkeitListe_0"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                      <ng-template #popover_antragsteller_staatsangehoerigkeitListe_0>
                        <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                       (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte wählen Sie hier die derzeitige Staatsangehörigkeit des/der Antragstellenden aus (wie im Reisedokument angegeben). Sollte diese(r) eine oder mehrere weitere Staatsangehörigkeiten besitzen, geben Sie diese bitte zusätzlich im nächsten Feld an (es können maximal 3 Staatsangehörigkeiten angegeben werden).</span>
                        </app-assistant>
                        <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                       (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier die derzeitige Staatsangehörigkeit des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                        </app-assistant>
                      </ng-template>
                    </span>
                    <span>
                      <select *ngIf="form.value.derzeitigeStaatsangehoerigkeit1"
                              id="antragsteller.staatsangehoerigkeitListe[1]" class="form-select form-select-sm mb-2"
                              formControlName="derzeitigeStaatsangehoerigkeit2"
                              [ngbPopover]="popover_antragsteller_staatsangehoerigkeitListe_1"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                      <ng-template #popover_antragsteller_staatsangehoerigkeitListe_1>
                        <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                       (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte wählen Sie hier die derzeitige Staatsangehörigkeit des/der Antragstellenden aus (wie im Reisedokument angegeben). Sollte diese(r) eine oder mehrere weitere Staatsangehörigkeiten besitzen, geben Sie diese bitte zusätzlich im nächsten Feld an (es können maximal 3 Staatsangehörigkeiten angegeben werden).</span>
                        </app-assistant>
                        <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                       (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier, sofern vorhanden, eine weitere Staatsangehörigkeit des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                        </app-assistant>
                      </ng-template>
                    </span>
                    <span>
                      <select *ngIf="form.value.derzeitigeStaatsangehoerigkeit2"
                              id="antragsteller.staatsangehoerigkeitListe[2]" class="form-select form-select-sm mb-2"
                              formControlName="derzeitigeStaatsangehoerigkeit3"
                              [ngbPopover]="popover_antragsteller_staatsangehoerigkeitListe_2"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                      <ng-template #popover_antragsteller_staatsangehoerigkeitListe_2>
                         <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                        (assistantDisabled)="disableAssistant()">
                           <span i18n>Bitte wählen Sie hier die derzeitige Staatsangehörigkeit des/der Antragstellenden aus (wie im Reisedokument angegeben). Sollte diese(r) eine oder mehrere weitere Staatsangehörigkeiten besitzen, geben Sie diese bitte zusätzlich im nächsten Feld an (es können maximal 3 Staatsangehörigkeiten angegeben werden).</span>
                        </app-assistant>
                        <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                       (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier, sofern vorhanden, eine weitere Staatsangehörigkeit des/der Antragstellenden ein (wie im Reisedokument angegeben).</span>
                        </app-assistant>
                      </ng-template>
                    </span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.staatsangehoerigkeitBeiGeburtListe[0]" i18n
                           [class.mandatory]="isMandatory('staatsangehoerigkeitBeiGeburt1')"
                           *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">Frühere Staatsangehörigkeit:</label>
                    <label for="antragsteller.staatsangehoerigkeitBeiGeburtListe[0]" i18n
                           [class.mandatory]="isMandatory('staatsangehoerigkeitBeiGeburt1')"
                           *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">Staatsangehörigkeit bei der Geburt (falls abweichend):</label>
                    <span>
                      <select id="antragsteller.staatsangehoerigkeitBeiGeburtListe[0]" class="form-select form-select-sm mb-2"
                              [class.is-invalid]="errorClassRequired(form.controls['staatsangehoerigkeitBeiGeburt1'])"
                              formControlName="staatsangehoerigkeitBeiGeburt1"
                              [ngbPopover]="popover_antragsteller_staatsangehoerigkeitBeiGeburtListe_0"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                      <ng-template #popover_antragsteller_staatsangehoerigkeitBeiGeburtListe_0>
                        <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                       (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte wählen Sie hier, sofern abweichend von der derzeitigen Staatsangehörigkeit, die Staatsangehörigkeit des/der Antragstellenden bei Geburt aus.</span>
                        </app-assistant>
                        <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                       (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier, sofern abweichend von der derzeitigen Staatsangehörigkeit, die Staatsangehörigkeit des/der Antragstellenden bei Geburt ein.</span>
                        </app-assistant>
                      </ng-template>
                    </span>
                    <span>
                      <select *ngIf="form.value.staatsangehoerigkeitBeiGeburt1 && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                              id="antragsteller.staatsangehoerigkeitBeiGeburtListe[1]" class="form-select form-select-sm mb-2"
                              formControlName="staatsangehoerigkeitBeiGeburt2"
                              [ngbPopover]="popover_antragsteller_staatsangehoerigkeitBeiGeburtListe_1"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                       <ng-template #popover_antragsteller_staatsangehoerigkeitBeiGeburtListe_1>
                         <app-assistant (assistantDisabled)="disableAssistant()">
                           <span i18n>Bitte wählen Sie hier, sofern abweichend von der derzeitigen Staatsangehörigkeit, die Staatsangehörigkeit des/der Antragstellenden bei Geburt aus.</span>
                         </app-assistant>
                       </ng-template>
                    </span>
                    <span>
                      <select *ngIf="form.value.staatsangehoerigkeitBeiGeburt2 && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                              id="antragsteller.staatsangehoerigkeitBeiGeburtListe[2]" class="form-select form-select-sm mb-2"
                              formControlName="staatsangehoerigkeitBeiGeburt3"
                              [ngbPopover]="popover_antragsteller_staatsangehoerigkeitBeiGeburtListe_2"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                       <ng-template #popover_antragsteller_staatsangehoerigkeitBeiGeburtListe_2>
                         <app-assistant (assistantDisabled)="disableAssistant()">
                           <span i18n>Bitte wählen Sie hier, sofern abweichend von der derzeitigen Staatsangehörigkeit, die Staatsangehörigkeit des/der Antragstellenden bei Geburt aus.</span>
                         </app-assistant>
                       </ng-template>
                    </span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3" *ngIf="appConfig.isHasKinderActive">
                    <label for="antragsteller.personendaten.kinder.vorhanden">
                      <span i18n>Haben Sie Kinder?</span><br>
                      <span i18n>(Bitte berücksichtigen Sie auch volljährige bzw. nicht mitreisende Kinder bei der Angabe.)</span>
                    </label>
                    <div class="form-check">
                      <input id="antragsteller.personendaten.kinder.vorhanden"
                             class="form-check-input"
                             type="checkbox"
                             formControlName="hasKinder"
                             [ngbPopover]="popover_antragsteller_personendaten_kinder_vorhanden"
                             appSaveLastFocussed
                      >
                      <span i18n>ja</span>
                      <ng-template #popover_antragsteller_personendaten_kinder_vorhanden>
                        <app-assistant (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte berücksichtigen Sie auch volljährige bzw. nicht mitreisende Kinder bei der Angabe.</span>
                        </app-assistant>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                <div class="col-md-12">
                  <div class="mb-3">
                    <span i18n>Familienangehörigen von EU-Staatsangehörigen und Staatsangehörigen des EWR oder der Schweiz oder von einer/einem Staatsangehörigen des Vereinigten Königreichs, die/der Begünstigte/r des Austrittsabkommens zwischen der EU und dem Vereinigten Königreich ist (Ehegatte, Kind oder abhängige(r) Verwandte(r) in aufsteigender Linie), ist es in Ausübung ihres Rechts auf Freizügigkeit freigestellt, Angaben zu ihrer beruflichen Tätigkeit, der Referenz oder der Finanzierung ihres Aufenthalts zu machen. Gehört der/die Antragstellende zu diesem Personenkreis und möchte keine Angaben machen, wählen Sie bitte „Ja“. Die Verwandtschaftsbeziehung muss anhand von Dokumenten nachgewiesen werden.</span>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                <div class="col-md-12">
                  <div class="mb-3">
                    <span i18n>Möchten Sie Ihr Recht auf Freizügigkeit ausüben?</span>
                    <div class="form-check">
                      <input id="rechtAufFreizuegigkeit"
                             class="form-check-input" type="checkbox"
                             formControlName="isRechtAufFreizuegigkeit"
                             [ngbPopover]="popover_rechtAufFreizuegigkeit"
                             appSaveLastFocussed
                      >
                      <label for="rechtAufFreizuegigkeit" i18n>ja</label>
                    </div>
                    <ng-template #popover_rechtAufFreizuegigkeit>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Familienangehörigen von EU-Staatsangehörigen und Staatsangehörigen des EWR oder der Schweiz oder von einer/einem Staatsangehörigen des Vereinigten Königreichs, die/der Begünstigte/r des Austrittsabkommens zwischen der EU und dem Vereinigten Königreich ist (Ehegatte, Kind oder abhängige(r) Verwandte(r) in aufsteigender Linie), ist es in Ausübung ihres Rechts auf Freizügigkeit freigestellt, Angaben zu ihrer beruflichen Tätigkeit, der Referenz oder der Finanzierung ihres Aufenthalts zu machen. Gehört der/die Antragstellende zu diesem Personenkreis und möchte keine Angaben machen, wählen Sie bitte „Ja“. Die Verwandtschaftsbeziehung muss anhand von Dokumenten nachgewiesen werden.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>

                <app-verwandter *ngIf="isAngabenZumUnionsbuergerVisible" formControlName="verwandter"></app-verwandter>

              </div>

            </div>
          </div>

          <div *ngIf="appConfig.isHasKinderActive && form.value.hasKinder">
            <div formArrayName="kinder">
              <app-kind *ngFor="let kind of kindControls; let i = index" [formControlName]="i" [childIndex]="i"
                        [deletable]="i > 0 && this.appConfig.presentationMode === presentationModeEnum.DEFAULT" (delete)="removeKind(i)">
              </app-kind>
            </div>
            <div *ngIf="isAddKindVisible() && this.appConfig.presentationMode === presentationModeEnum.DEFAULT" class="row" (click)="addKind()">
              <div class="col-md-12 m-3 kind-hinzufuegen-link">
                <h5><i class="icon-new"></i> <span i18n>Weiteres Kind zum Datensatz hinzufügen</span></h5>
              </div>
            </div>
          </div>

          <div class="row mt-3" *ngIf="isEhegatteVisible">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header card-header-detail" i18n>Angaben zur Ehegattin/zum Ehegatten/zur Lebenspartnerin/zum Lebenspartner</div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.ehegatte.familienname" i18n [class.mandatory]="isMandatory('ehegatteFamilienname')">Familienname:</label>
                        <input id="antragsteller.personendaten.ehegatte.familienname" type="text" appToUpperCase
                               [attr.maxlength]="getMaxLength('ehegatteFamilienname')" class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['ehegatteFamilienname'])"
                               formControlName="ehegatteFamilienname"
                               [ngbPopover]="popover_antragsteller_personendaten_ehegatte_familienname"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_ehegatte_familienname>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier den Familiennamen der Ehegattin/Lebenspartnerin, des Ehegatten/Lebenspartners ein. Angaben im gesamten Bereich sind auch erforderlich, falls diese Person im Ausland verbleibt. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.ehegatte.geburtsname" i18n [class.mandatory]="isMandatory('ehegatteGeburtsname')"
                        >Geburtsname / frühere(r) Familienname(n):</label>
                        <input id="antragsteller.personendaten.ehegatte.geburtsname" type="text" appToUpperCase
                               [attr.maxlength]="getMaxLength('ehegatteGeburtsname')" class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['ehegatteGeburtsname'])"
                               formControlName="ehegatteGeburtsname"
                               [ngbPopover]="popover_antragsteller_personendaten_ehegatte_geburtsname"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_ehegatte_geburtsname>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier – falls zutreffend – den Geburtsnamen und/oder frühere(n) Familiennamen der Ehegattin/Lebenspartnerin, des Ehegatten/Lebenspartners ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden. Sollte sich der Name nicht geändert haben, lassen Sie dieses Feld bitte frei.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.ehegatte.vorname" i18n
                               [class.mandatory]="isMandatory('ehegatteVorname')">Vorname(n):</label>
                        <input id="antragsteller.personendaten.ehegatte.vorname" type="text" appToUpperCase
                               [attr.maxlength]="getMaxLength('ehegatteVorname')" class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['ehegatteVorname'])" formControlName="ehegatteVorname"
                               [ngbPopover]="popover_antragsteller_personendaten_ehegatte_vorname"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_ehegatte_vorname>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier den/die Vorname(n) der Ehegattin/Lebenspartnerin, des Ehegatten/Lebenspartners ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.ehegatte.geburtsdatum" i18n [class.mandatory]="isMandatory('ehegatteGeburtsdatum')"
                        >Geburtsdatum (TT.MM.JJJJ):</label>
                        <input id="antragsteller.personendaten.ehegatte.geburtsdatum"
                               type="text"
                               appDynamicDateMaxLength
                               class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['ehegatteGeburtsdatum'])"
                               formControlName="ehegatteGeburtsdatum"
                               appFixDate="past"
                               unknownReplacement="00"
                               [ngbPopover]="popover_antragsteller_personendaten_ehegatte_geburtsdatum"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_ehegatte_geburtsdatum>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier das Datum im Format TT.MM.JJJJ ein, an dem die Ehegattin/Lebenspartnerin, der Ehegatte/Lebenspartner geboren wurde. Texteingabe in lateinischer Schrift (Deutsch/Englisch) ist möglich, falls das genaue Datum nicht bekannt sein sollte.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.ehegatte.geburtsort" i18n [class.mandatory]="isMandatory('ehegatteGeburtsort')">Geburtsort:</label>
                        <input id="antragsteller.personendaten.ehegatte.geburtsort" type="text" appToUpperCase
                               [attr.maxlength]="getMaxLength('ehegatteGeburtsort')" class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['ehegatteGeburtsort'])"
                               formControlName="ehegatteGeburtsort"
                               [ngbPopover]="popover_antragsteller_personendaten_ehegatte_geburtsort"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_ehegatte_geburtsort>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier – falls bekannt – den Ort ein, in dem die/der Ehegattin/Lebenspartnerin/Ehegatte/Lebenspartner geboren wurde.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.ehegatte.geburtsland" i18n [class.mandatory]="isMandatory('ehegatteGeburtsland')">Geburtsland:</label>
                        <select id="antragsteller.personendaten.ehegatte.geburtsland" class="form-select form-select-sm"
                                [class.is-invalid]="errorClassRequired(form.controls['ehegatteGeburtsland'])"
                                formControlName="ehegatteGeburtsland"
                                [ngbPopover]="popover_antragsteller_personendaten_ehegatte_geburtsland"
                                appSaveLastFocussed
                        >
                          <option value="" selected></option>
                          <option *ngFor="let listItem of landListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                        </select>
                        <ng-template #popover_antragsteller_personendaten_ehegatte_geburtsland>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte wählen Sie hier das Land aus, in dem die Ehegattin/Lebenspartnerin, der Ehegatte/Lebenspartner geboren wurde.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="">
                        <label for="antragsteller.personendaten.ehegatte.staatsangehoerigkeitListe[0]" i18n>Derzeitige Staatsangehörigkeit:</label>
                        <span>
                          <select id="antragsteller.personendaten.ehegatte.staatsangehoerigkeitListe[0]"
                                  class="form-select form-select-sm mb-2"
                                  [class.is-invalid]="errorClassRequired(form.controls['ehegatteDerzeitigeStaatsangehoerigkeit1'])"
                                  formControlName="ehegatteDerzeitigeStaatsangehoerigkeit1"
                                  [ngbPopover]="popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitListe_0"
                                  appSaveLastFocussed
                          >
                            <option value="">---</option>
                            <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                          </select>
                          <ng-template #popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitListe_0>
                           <app-assistant (assistantDisabled)="disableAssistant()">
                             <span i18n>Bitte wählen Sie hier – falls bekannt – die derzeitige Staatsangehörigkeit der Ehegattin/Lebenspartnerin, des Ehegatten/Lebenspartners aus.</span>
                           </app-assistant>
                          </ng-template>
                        </span>
                        <span>
                          <select *ngIf="form.value.ehegatteDerzeitigeStaatsangehoerigkeit1"
                                  id="antragsteller.personendaten.ehegatte.staatsangehoerigkeitListe[1]"
                                  class="form-select form-select-sm mb-2"
                                  formControlName="ehegatteDerzeitigeStaatsangehoerigkeit2"
                                  [ngbPopover]="popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitListe_1"
                                  appSaveLastFocussed
                          >
                            <option value="">---</option>
                            <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                          </select>
                          <ng-template #popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitListe_1>
                            <app-assistant (assistantDisabled)="disableAssistant()">
                              <span i18n>Bitte wählen Sie hier – falls bekannt – die derzeitige Staatsangehörigkeit der Ehegattin/Lebenspartnerin, des Ehegatten/Lebenspartners aus.</span>
                            </app-assistant>
                          </ng-template>
                        </span>
                        <span>
                          <select *ngIf="form.value.ehegatteDerzeitigeStaatsangehoerigkeit2"
                                  id="antragsteller.personendaten.ehegatte.staatsangehoerigkeitListe[2]"
                                  class="form-select form-select-sm mb-2"
                                  formControlName="ehegatteDerzeitigeStaatsangehoerigkeit3"
                                  [ngbPopover]="popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitListe_2"
                                  appSaveLastFocussed
                          >
                            <option value="">---</option>
                            <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                          </select>
                           <ng-template #popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitListe_2>
                             <app-assistant (assistantDisabled)="disableAssistant()">
                               <span i18n>Bitte wählen Sie hier – falls bekannt – die derzeitige Staatsangehörigkeit der Ehegattin/Lebenspartnerin, des Ehegatten/Lebenspartners aus.</span>
                             </app-assistant>
                           </ng-template>
                        </span>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="">
                        <label for="antragsteller.personendaten.ehegatte.staatsangehoerigkeitBeiGeburtListe[0]" i18n
                               [class.mandatory]="isMandatory('ehegatteStaatsangehoerigkeitBeiGeburt1')">Frühere Staatsangehörigkeit:</label>
                        <span>
                          <select id="antragsteller.personendaten.ehegatte.staatsangehoerigkeitBeiGeburtListe[0]"
                                  class="form-select form-select-sm mb-2"
                                  [class.is-invalid]="errorClassRequired(form.controls['ehegatteStaatsangehoerigkeitBeiGeburt1'])"
                                  formControlName="ehegatteStaatsangehoerigkeitBeiGeburt1"
                                  [ngbPopover]="popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitBeiGeburtListe_0"
                                  appSaveLastFocussed
                          >
                            <option value="">---</option>
                            <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                          </select>
                           <ng-template #popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitBeiGeburtListe_0>
                             <app-assistant (assistantDisabled)="disableAssistant()">
                               <span i18n>Bitte wählen Sie – falls zutreffend und bekannt – frühere Staatsangehörigkeiten der Ehegattin/Lebenspartnerin, des Ehegatten/Lebenspartners aus.</span>
                             </app-assistant>
                           </ng-template>
                        </span>
                        <span>
                          <select *ngIf="form.value.ehegatteStaatsangehoerigkeitBeiGeburt1"
                                  id="antragsteller.personendaten.ehegatte.staatsangehoerigkeitBeiGeburtListe[1]"
                                  class="form-select form-select-sm mb-2"
                                  formControlName="ehegatteStaatsangehoerigkeitBeiGeburt2"
                                  [ngbPopover]="popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitBeiGeburtListe_1"
                                  appSaveLastFocussed
                          >
                            <option value="">---</option>
                            <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                          </select>
                          <ng-template #popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitBeiGeburtListe_1>
                            <app-assistant (assistantDisabled)="disableAssistant()">
                              <span i18n>Bitte wählen Sie – falls zutreffend und bekannt – frühere Staatsangehörigkeiten der Ehegattin/Lebenspartnerin, des Ehegatten/Lebenspartners aus.</span>
                            </app-assistant>
                          </ng-template>
                        </span>
                        <span>
                          <select *ngIf="form.value.ehegatteStaatsangehoerigkeitBeiGeburt2"
                                  id="antragsteller.personendaten.ehegatte.staatsangehoerigkeitBeiGeburtListe[2]"
                                  class="form-select form-select-sm mb-2"
                                  formControlName="ehegatteStaatsangehoerigkeitBeiGeburt3"
                                  [ngbPopover]="popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitBeiGeburtListe_2"
                                  appSaveLastFocussed
                          >
                            <option value="">---</option>
                            <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                          </select>
                          <ng-template #popover_antragsteller_personendaten_ehegatte_staatsangehoerigkeitBeiGeburtListe_2>
                            <app-assistant (assistantDisabled)="disableAssistant()">
                              <span i18n>Bitte wählen Sie – falls zutreffend und bekannt – frühere Staatsangehörigkeiten der Ehegattin/Lebenspartnerin, des Ehegatten/Lebenspartners aus.</span>
                            </app-assistant>
                          </ng-template>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="">
                        <label for="antragsteller.personendaten.ehegatte.wohnort" i18n
                               [class.mandatory]="isMandatory('ehegatteWohnort')">Wohnort:</label>
                        <input id="antragsteller.personendaten.ehegatte.wohnort"
                               type="text" appToUpperCase
                               [attr.maxlength]="getMaxLength('ehegatteWohnort')"
                               class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['ehegatteWohnort'])"
                               formControlName="ehegatteWohnort"
                               [ngbPopover]="popover_antragsteller_personendaten_ehegatte_wohnort"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_ehegatte_wohnort>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier – falls bekannt – den Ort ein, in dem die/der Ehegattin/Lebenspartnerin/Ehegatte/Lebenspartner wohnt.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header card-header-detail">
                  <label i18n *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">Eltern des/der Antragstellenden</label>
                  <label i18n *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                  Inhaber der elterlichen Sorge (bei Minderjährigen) / Vormund des/der Antragstellenden
                  </label>
              </div>
                <div class="card-body">
                  <p *ngIf="(isMinderjaehrige$ | async) && checkParentControlErrors()"
                     style="font-weight: bold; color:#ca7d7d" i18n>
                    Aufgrund der Minderjährigkeit des/der Antragsstellenden muss mindestens eine Person benannt werden.
                  </p>

                  <div class="row">
                    <div class="col-md-4">

                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.vater.familienname" i18n
                               [class.mandatory]="isMandatory('familiennameVater')"
                               *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">
                          Familienname des Vaters:</label>
                        <label for="antragsteller.personendaten.eltern.vater.familienname" i18n
                               [class.mandatory]="isMandatory('familiennameVater') || isElternErsteZeileRequired"
                               *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                          Familienname:</label>
                        <input id="antragsteller.personendaten.eltern.vater.familienname"
                               type="text" appToUpperCase
                               [attr.maxlength]="getMaxLength('familiennameVater')"
                               class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['familiennameVater'])"
                               formControlName="familiennameVater"
                               [ngbPopover]="popover_antragsteller_personendaten_eltern_vater_familienname"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_eltern_vater_familienname>
                          <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                         (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier den Familiennamen des Vaters des/der Antragstellenden ein. Angaben zum Vater im gesamten Bereich sind auch erforderlich, falls er im Ausland verbleibt. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                          </app-assistant>
                          <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                         (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier den Familiennamen des/der Inhabenden der elterlichen Sorge (bei Minderjährigen) bzw. des Vormunds des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">

                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.vater.vorname" i18n
                               [class.mandatory]="isMandatory('vornameVater')"
                               *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">
                          Vorname(n) des Vaters:</label>
                        <label for="antragsteller.personendaten.eltern.vater.vorname" i18n
                               [class.mandatory]="isMandatory('vornameVater') || isElternErsteZeileRequired"
                               *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                          Vorname(n):</label>
                        <input id="antragsteller.personendaten.eltern.vater.vorname" type="text" appToUpperCase
                               [attr.maxlength]="getMaxLength('vornameVater')" class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['vornameVater'])" formControlName="vornameVater"
                               [ngbPopover]="popover_antragsteller_personendaten_eltern_vater_vorname"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_eltern_vater_vorname>
                          <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                         (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier den/die Vornamen des Vaters des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                          </app-assistant>
                          <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                         (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier den/die Vornamen des/der Inhabenden der elterlichen Sorge (bei Minderjährigen) bzw. des Vormunds des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.vater.staatsangehoerigkeitListe[0]" i18n
                               *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">
                          Staatsangehörigkeit des Vaters:</label>
                        <label for="antragsteller.personendaten.eltern.vater.staatsangehoerigkeitListe[0]" i18n
                               [class.mandatory]="isMandatory('staatsangehoerigkeitVater') || isElternErsteZeileRequired"
                               *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                          Staatsangehörigkeit:</label>
                        <select id="antragsteller.personendaten.eltern.vater.staatsangehoerigkeitListe[0]"
                                class="form-select form-select-sm"
                                [class.is-invalid]="errorClassRequired(form.controls['staatsangehoerigkeitVater'])"
                                formControlName="staatsangehoerigkeitVater"
                                [ngbPopover]="popover_antragsteller_personendaten_eltern_vater_staatsangehoerigkeitListe_0"
                                appSaveLastFocussed
                        >
                          <option value="">---</option>
                          <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                        </select>
                        <ng-template #popover_antragsteller_personendaten_eltern_vater_staatsangehoerigkeitListe_0>
                          <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                         (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte wählen Sie hier die Staatsangehörigkeit des Vaters des/der Antragstellenden aus.</span>
                          </app-assistant>
                          <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                         (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier die Staatsangehörigkeit des/der Inhabenden der elterlichen Sorge (bei Minderjährigen) bzw. des Vormunds des/der Antragstellenden ein.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                  </div>

                  <div class="row" *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.vater.geburtsdatum" i18n [class.mandatory]="isMandatory('geburtsdatumVater')"
                        >Geburtsdatum des Vaters:</label>
                        <input id="antragsteller.personendaten.eltern.vater.geburtsdatum"
                               type="text"
                               appToUpperCase
                               [attr.maxlength]="getMaxLength('geburtsdatumVater')"
                               class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['geburtsdatumVater'])"
                               formControlName="geburtsdatumVater"
                               [ngbPopover]="popover_antragsteller_personendaten_eltern_vater_geburtsdatum"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_eltern_vater_geburtsdatum>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier – falls bekannt – das Geburtsdatum des Vaters des/der Antragstellenden ein. Texteingaben in lateinischer Schrift (Deutsch/Englisch) sind möglich.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.vater.geburtsort" i18n [class.mandatory]="isMandatory('geburtsortVater')"
                        >Geburtsort des Vaters:</label>
                        <input id="antragsteller.personendaten.eltern.vater.geburtsort"
                               type="text" appToUpperCase
                               [attr.maxlength]="getMaxLength('geburtsortVater')"
                               class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['geburtsortVater'])"
                               formControlName="geburtsortVater"
                               [ngbPopover]="popover_antragsteller_personendaten_eltern_vater_geburtsort"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_eltern_vater_geburtsort>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier – falls bekannt - den Geburtsort des Vaters des/der Antragstellenden ein.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.vater.wohnort" i18n [class.mandatory]="isMandatory('wohnortVater')"
                        >Wohnort des Vaters:</label>
                        <input id="antragsteller.personendaten.eltern.vater.wohnort"
                               type="text"
                               appToUpperCase
                               [attr.maxlength]="getMaxLength('wohnortVater')"
                               class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['wohnortVater'])"
                               formControlName="wohnortVater"
                               [ngbPopover]="popover_antragsteller_personendaten_eltern_vater_wohnort"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_eltern_vater_wohnort>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier – falls bekannt – den Wohnort des Vaters des/der Antragstellenden ein. Falls der Vater bereits verstorben ist, vermerken Sie es bitte hier in lateinischer Schrift (Deutsch/Englisch).</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.mutter.familienname" i18n
                               [class.mandatory]="isMandatory('familiennameMutter')"
                               *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">
                          Familienname der Mutter:</label>
                        <label for="antragsteller.personendaten.eltern.mutter.familienname" i18n
                               *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                          Familienname:</label>
                        <input id="antragsteller.personendaten.eltern.mutter.familienname"
                               type="text"
                               appToUpperCase
                               [attr.maxlength]="getMaxLength('familiennameMutter')"
                               class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['familiennameMutter'])"
                               formControlName="familiennameMutter"
                               [ngbPopover]="popover_antragsteller_personendaten_eltern_mutter_familienname"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_eltern_mutter_familienname>
                          <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                         (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier den Familiennamen der Mutter des/der Antragstellenden ein. Angaben zur Mutter im gesamten Bereich sind auch erforderlich, falls sie im Ausland verbleibt. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                          </app-assistant>
                          <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                         (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier den Familiennamen des/der Inhabenden der elterlichen Sorge (bei Minderjährigen) bzw. des Vormunds des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.mutter.vorname" i18n
                               [class.mandatory]="isMandatory('vornameMutter')"
                               *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">
                          Vorname(n) der Mutter:</label>
                        <label for="antragsteller.personendaten.eltern.mutter.vorname" i18n
                               *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                          Vorname(n):</label>
                        <input id="antragsteller.personendaten.eltern.mutter.vorname"
                               type="text"
                               appToUpperCase
                               [attr.maxlength]="getMaxLength('vornameMutter')"
                               class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['vornameMutter'])"
                               formControlName="vornameMutter"
                               [ngbPopover]="popover_antragsteller_personendaten_eltern_mutter_vorname"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_eltern_mutter_vorname>
                          <app-assistant *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier den/die Vornamen der Mutter des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                          </app-assistant>
                          <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                         (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier den/die Vornamen des/der Inhabenden der elterlichen Sorge (bei Minderjährigen) bzw. des Vormunds des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.mutter.staatsangehoerigkeitListe[0]" i18n
                               *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">
                          Staatsangehörigkeit der Mutter:</label>
                        <label for="antragsteller.personendaten.eltern.mutter.staatsangehoerigkeitListe[0]" i18n
                               *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                          Staatsangehörigkeit:</label>
                        <select id="antragsteller.personendaten.eltern.mutter.staatsangehoerigkeitListe[0]"
                                class="form-select form-select-sm"
                                [class.is-invalid]="errorClassRequired(form.controls['staatsangehoerigkeitMutter'])"
                                formControlName="staatsangehoerigkeitMutter"
                                [ngbPopover]="popover_antragsteller_personendaten_eltern_mutter_staatsangehoerigkeitListe_0"
                                appSaveLastFocussed
                        >
                          <option value="">---</option>
                          <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                        </select>
                        <ng-template #popover_antragsteller_personendaten_eltern_mutter_staatsangehoerigkeitListe_0>
                          <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                         (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte wählen Sie hier die Staatsangehörigkeit der Mutter des/der Antragstellenden aus.</span>
                          </app-assistant>
                          <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                         (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier die Staatsangehörigkeit des/der Inhabenden der elterlichen Sorge (bei Minderjährigen) bzw. des Vormunds des/der Antragstellenden ein.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                  </div>

                  <div class="row" *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.mutter.geburtsdatum" i18n
                               [class.mandatory]="isMandatory('geburtsdatumMutter')">Geburtsdatum der Mutter:</label>
                        <input id="antragsteller.personendaten.eltern.mutter.geburtsdatum"
                               type="text"
                               appToUpperCase
                               [attr.maxlength]="getMaxLength('geburtsdatumMutter')"
                               class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['geburtsdatumMutter'])"
                               formControlName="geburtsdatumMutter"
                               [ngbPopover]="popover_antragsteller_personendaten_eltern_mutter_geburtsdatum"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_eltern_mutter_geburtsdatum>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier – falls bekannt – das Geburtsdatum der Mutter des/der Antragstellenden ein. Texteingaben in lateinischer Schrift (Deutsch/Englisch) sind möglich.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.mutter.geburtsort" i18n [class.mandatory]="isMandatory('geburtsortMutter')"
                        >Geburtsort der Mutter:</label>
                        <input id="antragsteller.personendaten.eltern.mutter.geburtsort" type="text" appToUpperCase
                               [attr.maxlength]="getMaxLength('geburtsortMutter')" class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['geburtsortMutter'])" formControlName="geburtsortMutter"
                               [ngbPopover]="popover_antragsteller_personendaten_eltern_mutter_geburtsort"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_eltern_mutter_geburtsort>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier – falls bekannt - den Geburtsort der Mutter des/der Antragstellenden ein.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.eltern.mutter.wohnort" i18n [class.mandatory]="isMandatory('wohnortMutter')"
                        >Wohnort der Mutter:</label>
                        <input id="antragsteller.personendaten.eltern.mutter.wohnort"
                               type="text"
                               appToUpperCase
                               [attr.maxlength]="getMaxLength('wohnortMutter')"
                               class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['wohnortMutter'])"
                               formControlName="wohnortMutter"
                               [ngbPopover]="popover_antragsteller_personendaten_eltern_mutter_wohnort"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_eltern_mutter_wohnort>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier – falls bekannt – den Wohnort der Mutter des/der Antragstellenden ein. Falls die Mutter bereits verstorben ist, vermerken Sie es bitte hier in lateinischer Schrift (Deutsch/Englisch).</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="mb-3">
                          <label for="antragsteller.personendaten.eltern.anschrift" i18n [class.mandatory]="isMandatory('anschriftEltern')"
                          >Anschrift (nur wenn abweichend von der Wohnanschrift des/der Antragstellenden):</label>
                          <input id="antragsteller.personendaten.eltern.anschrift"
                                 type="text"
                                 appToUpperCase
                                 [attr.maxlength]="getMaxLength('anschriftEltern')"
                                 class="form-control form-control-sm"
                                 [class.is-invalid]="errorClassRequired(form.controls['anschriftEltern'])"
                                 formControlName="anschriftEltern"
                                 [ngbPopover]="popover_antragsteller_personendaten_eltern_anschrift"
                                 appSaveLastFocussed
                          >
                          <ng-template #popover_antragsteller_personendaten_eltern_anschrift>
                            <app-assistant (assistantDisabled)="disableAssistant()">
                              <span
                                i18n>Bitte tragen Sie hier die aktuelle Wohnanschrift des/der Inhabenden der elterlichen Sorge (bei Minderjährigen) bzw. des Vormunds des/der Antragstellenden ein.</span>
                            </app-assistant>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="mb-3">
                          <label for="antragsteller.personendaten.eltern.kontaktdaten.telefon" i18n [class.mandatory]="isMandatory('telefonEltern')">Telefon-/Mobilfunknummer:</label>
                          <input id="antragsteller.personendaten.eltern.kontaktdaten.telefon"
                                 type="text"
                                 appToUpperCase
                                 [attr.maxlength]="getMaxLength('telefonEltern')"
                                 class="form-control form-control-sm"
                                 [class.is-invalid]="errorClassRequired(form.controls['telefonEltern'])"
                                 formControlName="telefonEltern"
                                 [ngbPopover]="popover_antragsteller_personendaten_eltern_kontaktdaten_telefon"
                                 appSaveLastFocussed
                          >
                          <ng-template #popover_antragsteller_personendaten_eltern_kontaktdaten_telefon>
                            <app-assistant (assistantDisabled)="disableAssistant()">
                              <span i18n>Bitte tragen Sie hier die aktuelle Telefonnummer eines Elternteils bzw. des Vormunds des/der Antragstellenden ein.</span>
                            </app-assistant>
                          </ng-template>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-3">
                          <label for="antragsteller.personendaten.eltern.kontaktdaten.email" i18n [class.mandatory]="isMandatory('emailEltern')">E-Mail:</label>
                          <input id="antragsteller.personendaten.eltern.kontaktdaten.email"
                                 type="text" appToUpperCase
                                 [attr.maxlength]="getMaxLength('emailEltern')"
                                 class="form-control form-control-sm"
                                 [class.is-invalid]="errorClassRequired(form.controls['emailEltern'])"
                                 formControlName="emailEltern"
                                 [ngbPopover]="popover_antragsteller_personendaten_eltern_kontaktdaten_email"
                                 appSaveLastFocussed
                          >
                          <ng-template #popover_antragsteller_personendaten_eltern_kontaktdaten_email>
                            <app-assistant (assistantDisabled)="disableAssistant()">
                              <span i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse eines Elternteils bzw. des Vormunds des/der Antragstellenden ein.</span>
                            </app-assistant>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3" *ngIf="isBerufLangfristigerAufenthaltVisible">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header card-header-detail" i18n>Beruf</div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.berufdaten.berufAuswahl" i18n [class.mandatory]="isMandatory('berufAuswahl')"
                        >Erlernter Beruf:</label>
                        <select id="antragsteller.personendaten.berufdaten.berufAuswahl"
                                class="form-select form-select-sm"
                                [class.is-invalid]="errorClassRequired(form.controls['berufAuswahl'])"
                                formControlName="berufAuswahl"
                                [ngbPopover]="popover_antragsteller_personendaten_berufdaten_berufAuswahl"
                                appSaveLastFocussed
                        >
                          <option value="" selected></option>
                          <option *ngFor="let listItem of berufListItems"
                                  value="{{ listItem.key }}">{{ listItem.value }}
                          </option>
                        </select>
                        <ng-template #popover_antragsteller_personendaten_berufdaten_berufAuswahl>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte wählen Sie hier den erlernten Beruf des/der Antragstellenden aus.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.berufdaten.berufSonstiges" [class.mandatory]="isMandatory('erlernterBerufSonstiges')"
                               i18n>ggf. weitere Angaben:</label>
                        <input id="antragsteller.personendaten.berufdaten.berufSonstiges" type="text" appToUpperCase
                               [attr.maxlength]="getMaxLength('erlernterBerufSonstiges')" class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['erlernterBerufSonstiges'])"
                               formControlName="erlernterBerufSonstiges"
                               [ngbPopover]="popover_antragsteller_personendaten_berufdaten_berufSonstiges"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_berufdaten_berufSonstiges>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Falls Sie ergänzende/erläuternde Angaben zum erlernten Beruf machen möchten, können Sie diese hier in lateinischer Schrift (Deutsch/Englisch) eintragen.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.berufdaten.derzeitigeBeruflicheTaetigkeit"
                               [class.mandatory]="isMandatory('derzeitigerBeruf')" i18n>Derzeitige berufliche Tätigkeit (sofern abweichend):</label>
                        <input id="antragsteller.personendaten.berufdaten.derzeitigeBeruflicheTaetigkeit"
                               type="text"
                               appToUpperCase
                               [attr.maxlength]="getMaxLength('derzeitigerBeruf')"
                               class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['derzeitigerBeruf'])"
                               formControlName="derzeitigerBeruf"
                               [ngbPopover]="popover_antragsteller_personendaten_berufdaten_derzeitigeBeruflicheTaetigkeit"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_berufdaten_derzeitigeBeruflicheTaetigkeit>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Bitte tragen Sie hier die derzeit ausgeübte berufliche Tätigkeit des/der Antragstellenden in lateinischer Schrift (Deutsch/Englisch) ein, sofern sie von der erlernten Tätigkeit abweicht.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="antragsteller.personendaten.berufdaten.derzeitigeBeruflicheTaetigkeitSonstiges"
                               [class.mandatory]="isMandatory('derzeitigerBerufSonstiges')" i18n>ggf. weitere Angaben:</label>
                        <input id="antragsteller.personendaten.berufdaten.derzeitigeBeruflicheTaetigkeitSonstiges" type="text" appToUpperCase
                               [attr.maxlength]="getMaxLength('derzeitigerBerufSonstiges')" class="form-control form-control-sm"
                               [class.is-invalid]="errorClassRequired(form.controls['derzeitigerBerufSonstiges'])"
                               formControlName="derzeitigerBerufSonstiges"
                               [ngbPopover]="popover_antragsteller_personendaten_berufdaten_derzeitigeBeruflicheTaetigkeitSonstiges"
                               appSaveLastFocussed
                        >
                        <ng-template #popover_antragsteller_personendaten_berufdaten_derzeitigeBeruflicheTaetigkeitSonstiges>
                          <app-assistant (assistantDisabled)="disableAssistant()">
                            <span i18n>Falls Sie ergänzende/erläuternde Angaben zur derzeitigen beruflichen Tätigkeit machen möchten, können Sie diese hier in lateinischer Schrift (Deutsch/Englisch) eintragen.</span>
                          </app-assistant>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <app-beruf-kurzfristiger-aufenthalt *ngIf="isBerufKurzfristigerAufenthaltVisible"
                                              formControlName="beruf"></app-beruf-kurzfristiger-aufenthalt>

        </div>
      </div>
    </div>


  </div>
</div>
